export default "__VITE_ASSET__DZ_zLm6c__"